// extracted by mini-css-extract-plugin
module.exports = {"yes_no_container":"YesNo-module__yes_no_container___69zqO","label":"YesNo-module__label___MtctO"};